import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ControlledTextField } from '../../../../shared/components';
import type { PocType } from '../../../services/poc.service';
import PocDirectorySelect from './PocDirectorySelect';

export default function POCContactSection({ title, path, headerActions }: { title: any; path: any; headerActions?: any }) {
  return (
    <div className='column'>
      <div className='row gap-5'>
        <Typography variant='body1' fontWeight={500} sx={{ whiteSpace: 'nowrap' }}>
          {title}
        </Typography>
        {headerActions}
      </div>

      <PocDirectorySelect type={path as PocType} path={path} />

      <Box className='grid grid--2-cols grid--with-divider'>
        <div className='column'>
          <ControlledTextField
            id={`${path}.name`}
            name={`${path}.name`}
            label='Full name'
            placeholder='Enter full name'
            rules={{
              minLength: { value: 3, message: 'Name must be at least 3 characters' },
              maxLength: { value: 100, message: 'Name cannot exceed 100 characters' },
            }}
          />

          <ControlledTextField
            id={`${path}.mobile`}
            name={`${path}.mobile`}
            label='Mobile number'
            placeholder='Enter mobile number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'Mobile number must be 10 digits' },
              maxLength: { value: 10, message: 'Mobile number must be 10 digits' },
            }}
          />

          <ControlledTextField
            id={`${path}.email`}
            name={`${path}.email`}
            label='Email address'
            placeholder='Enter email ID'
            type='email'
            rules={{
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Please enter a valid email address',
              },
            }}
          />
        </div>

        {/* Right column */}
        <div className='column'>
          <ControlledTextField
            id={`${path}.phone`}
            name={`${path}.phone`}
            label='Phone number'
            placeholder='Enter phone number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'Phone number must be 10 digits' },
              maxLength: { value: 10, message: 'Phone number must be 10 digits' },
            }}
          />

          <ControlledTextField
            id={`${path}.whatsapp`}
            name={`${path}.whatsapp`}
            label='WhatsApp number'
            placeholder='Enter WhatsApp number'
            inputMode='numeric'
            rules={{
              minLength: { value: 10, message: 'WhatsApp number must be 10 digits' },
              maxLength: { value: 10, message: 'WhatsApp number must be 10 digits' },
            }}
          />

          <ControlledTextField
            id={`${path}.officeAddress`}
            name={`${path}.officeAddress`}
            label='Office address'
            placeholder='Enter office address'
            isMultiline
            // rows={2}
            rules={{
              minLength: { value: 3, message: 'Address must be at least 3 characters' },
              maxLength: { value: 300, message: 'Address cannot exceed 300 characters' },
            }}
          />
        </div>
      </Box>
    </div>
  );
}
